import { useState } from "react";
import Homepage from "./pages/Homepage";
import VendasOnline from "./pages/VendasOnline";

function App() {
  const [count, setCount] = useState(0);

  const handleIncrement = () => {
    setCount(count + 1);
  };
  const handleDecrement = () => {
    setCount(count - 1);
  };

  return (
    // <BrowserRouter>
    //   <Switch>
    //     <Route path="/" exact component={Homepage} />
    //     <Route path="/vendasonline" exact component={VendasOnline} />

    //     <Redirect path="*" to="/" />
    //   </Switch>
    // </BrowserRouter>
    <>
      {count === 0 ? (
        <Homepage increment={handleIncrement} />
      ) : (
        <VendasOnline decrement={handleDecrement} />
      )}
    </>
  );
}

export default App;
